import { GenericConfirmationDialog } from '@/components/Analysis/shared/GeneriConfirmationDialog';
import { Button } from '@mui/material';
import { useBulkUploadPoiActions } from '../actions';

export const IncorrectHeadersDialog = () => {
  const { getGetBulkModalState, closeAllModals, getErrors } = useBulkUploadPoiActions();
  const errors = getErrors();
  const modalState = getGetBulkModalState();
  const isOpen = modalState === 'invalid_format';

  return (
    <GenericConfirmationDialog
      title="Incorrect “Template headers”"
      description={
        errors?.reason ||
        'The template headers in the file you uploaded are incorrect. Please upload a file with the correct template headers.'
      }
      onClose={closeAllModals}
      open={isOpen}
    >
      <Button onClick={closeAllModals}>OK</Button>
    </GenericConfirmationDialog>
  );
};
